<ng-template #addTicketModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Create Ticket</h4>
    <button type="button" class="close" (click)="closeModal(modal)" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body py-3" tabindex="0" ngbAutofocus>
    <form [formGroup]="form">
      <div class="row justify-content-between">
        <div class="col-md-4" style="border-right: 1px solid gray">
          <div class="row">
            <div class="form-group col-12">
              <label>Priority <span class="text-danger h4">*</span></label>
              <ng-select [items]="priorities" bindLabel="title" bindValue="id" placeholder="Select Priority"
                formControlName="priority" [clearable]="false">
              </ng-select>
              <small class="text-danger"
                *ngIf="this.fPriority?.errors?.['required'] && (this.fPriority?.touched || submitted)">
                This field is required.
              </small>
            </div>
            <div class="form-group col-12">
              <label>Related Service <span class="text-danger h4">*</span></label>
              <ng-select [items]="services" bindLabel="title" bindValue="id" placeholder="Select Related Service"
                formControlName="relatedService" [clearable]="false">
              </ng-select>
              <small class="text-danger"
                *ngIf="this.fRelatedService?.errors?.['required'] && (this.fRelatedService?.touched || submitted)">
                This field is required.
              </small>
            </div>
            <div class="form-group col-12" *renderIf="{
                roles: ['employee'],
                right: 'I1007'
              }">
              <label>Customer <span class="text-danger h4">*</span></label>
              <ng-select [items]="customers" bindLabel="name" bindValue="id" placeholder="Select Customer"
                formControlName="customerId" [loading]="customersLoading" [virtualScroll]="true" [clearable]="false">
              </ng-select>
              <small class="text-danger"
                *ngIf="this.fCustomerId?.errors?.['required'] && (this.fCustomerId?.touched || submitted)">
                This field is required.
              </small>
            </div>
            <div class="form-group col-12">
              <label>Project <span class="text-danger h4">*</span></label>
              <!-- <ng-select [items]="projects" bindLabel="title" bindValue="id" placeholder="Select Project"
                formControlName="projectId" [loading]="projectsLoading" [virtualScroll]="true" [clearable]="false"
                [readonly]="true">
              </ng-select> -->
              <select class="form-control" [value]="fProjectId?.value" readonly disabled>
                <option [value]="project.id" *ngFor="let project of projects">{{project.title}}</option>
              </select>
              <small class="text-danger"
                *ngIf="this.fProjectId?.errors?.['required'] && (this.fProjectId?.touched || submitted)">
                This field is required.
              </small>
            </div>
            <div class="form-group col-12">
              <label>Module </label>
              <!-- <ng-select [items]="modules" bindLabel="title" bindValue="id" placeholder="Select Module"
                formControlName="moduleId" [loading]="modulesLoading" [virtualScroll]="true" [clearable]="false"
                dropdownPosition="top">
              </ng-select> -->
              <select class="form-control" [value]="fModuleId?.value" readonly disabled>
                <option [value]="module.id" *ngFor="let module of modules">{{module.title}}</option>
              </select>
              <small class="text-danger"
                *ngIf="this.fModuleId?.errors?.['required'] && (this.fModuleId?.touched || submitted)">
                This field is required.
              </small>
            </div>
            <div class="form-group col-12">
              <label>Feature</label>
              <!-- <ng-select [items]="features" bindLabel="title" bindValue="id" placeholder="Select Feature"
                formControlName="featureId" [loading]="featuresLoading" [virtualScroll]="true" [clearable]="false"
                dropdownPosition="top">
              </ng-select> -->
              <select class="form-control" [value]="fFeatureId?.value" readonly disabled>
                <option [value]="feature.id" *ngFor="let feature of features">{{feature.title}}</option>
              </select>
              <small class="text-danger"
                *ngIf="this.fFeatureId?.errors?.['required'] && (this.fFeatureId?.touched || submitted)">
                This field is required.
              </small>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="row">
            <div class="form-group col-12">
              <label>Subject <span class="text-danger h4">*</span></label>
              <input type="text" formControlName="subject" placeholder="Subject" class="form-control" />
              <div class="text-danger" *ngIf="
                  this.fSubject?.errors && (this.fSubject?.touched || submitted)
                ">
                <small class="text-danger" *ngIf="this.fSubject?.errors?.['required']">
                  This field is required.
                </small>
                <small class="text-danger" *ngIf="this.fSubject?.errors?.['pattern']">
                  This input must include at least one letter or number and cannot consist solely of special characters
                  or digits.
                </small>
              </div>
            </div>
            <div class="form-group col-12">
              <quill-editor style="width: 100%; height: 200px" formControlName="body">
                <div quill-editor-toolbar>
                  <span class="ql-formats">
                    <button class="ql-bold" [title]="'Bold'"></button>
                    <button class="ql-italic" [title]="'italic'"></button>
                    <button class="ql-underline" [title]="'underline'"></button>
                  </span>
                  <span class="ql-formats">
                    <select class="ql-align" [title]="'Alignment'">
                      <option selected></option>
                      <option value="center"></option>
                      <option value="right"></option>
                      <option value="justify"></option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-list" value="ordered" type="button"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-link" value="ordered" type="button"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-clean" value="ordered" type="button"></button>
                  </span>
                </div>
              </quill-editor>
              <div class="text-danger" *ngIf="this.fBody?.errors && (this.fBody?.touched || submitted)">
                <small class="text-danger" *ngIf="this.fBody?.errors?.['required']">
                  This field is required.
                </small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-2">
              <div *ngFor="let file of files" class="files-list-item">
                <div>
                  <p>{{ file.name }}</p>
                  <!-- <span>{{ file.size }}</span> -->
                </div>
                <span class="waves-effect btn-flat-secondary" (click)="RemoveFile(file)">
                  <mat-icon fontIcon="delete"></mat-icon>
                </span>
              </div>
            </div>
            <div class="col-12 text-right">
              <label class="btn btn-primary btn-sm" for="multi-file-upload">
                <span [data-feather]="'paperclip'"></span>
                Attach Files
              </label>
              <input type="file" class="d-none" id="multi-file-upload" multiple (change)="onFileSelect($event)" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="click" class="btn btn-primary" rippleEffect (click)="onSubmit(modal)" *ngIf="!loading">
      {{ btnText }}
    </button>
    <button class="btn btn-outline-primary" type="button" disabled rippleEffect *ngIf="loading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span class="ml-25 align-middle">Loading.</span>
    </button>
  </div>
</ng-template>